import {
  Box,
  REPORT_BORDER_COLOR,
  type ReportTableCell,
  getCell,
} from '@/components';
import type { CSSProperties, FC } from 'react';

type Props = {
  vertical?: boolean;
  cellRatios?: (number | string)[];
  cells: ReportTableCell[];
  borderWidth?: string;
  borderStyle?: 'dotted' | 'solid';
  wrapperStyle?: CSSProperties;
  borderColor: 'primary' | 'secondary';
  isFlexStyle?: boolean;
};

export const FlexCells: FC<Props> = ({
  cells,
  vertical,
  cellRatios,
  borderWidth = '1px',
  borderStyle = 'solid',
  wrapperStyle,
  borderColor: borderColorType = 'primary',
  isFlexStyle,
}) => {
  const borderStyles = {
    [vertical ? 'borderTop' : 'borderLeft']:
      `${borderWidth} ${borderStyle} black`,
  };

  const borderColor = REPORT_BORDER_COLOR[borderColorType];

  const gridTemplateStyle = (cellRatios || [...Array(cells.length)].fill(1))
    .map((item) => (typeof item === 'number' ? `${item}fr` : item))
    .join(' ');

  const layoutStyles = vertical
    ? {
        display: 'grid',
        gridTemplateRows: gridTemplateStyle,
        gridTemplateColumns: '1fr',
      }
    : {
        display: 'grid',
        gridTemplateRows: '1fr',
        gridTemplateColumns: gridTemplateStyle,
        gridAutoFlow: 'column',
      };

  if (!cells.length) {
    return null;
  }

  return (
    <Box
      {...(isFlexStyle ? { display: 'flex' } : layoutStyles)}
      borderColor={borderColor}
      height="100%"
      boxSizing="border-box"
      {...wrapperStyle}
    >
      {cells.map((cell, index) => (
        <Box
          // biome-ignore lint/suspicious/noArrayIndexKey: biomeをCIに仕込むために暫定的にignore。keyにユニークな値を指定するか適切な理由に書き換えること
          key={index}
          {...(!!index && borderStyles)}
          height="100%"
          width={isFlexStyle ? '100%' : undefined}
          boxSizing="border-box"
          {...cell.wrapperStyle}
          borderColor={borderColor}
        >
          {getCell({ cell, borderColor: borderColorType })}
        </Box>
      ))}
    </Box>
  );
};
